/* Piobox PDP → quote list (2026-09-28).
 * Sits beside the PDP bundle (piobox-pdp.js) without touching it: reads the finished design off
 * the page (mock-up canvas, colour, sizes, price lines) and saves it as one quote line.
 *   · "Get a quote" becomes "Add to quote" — stays on the page, badge + status line update.
 *   · When a design can't go to cart ("Request this order"), the button becomes
 *     "Add to quote & send" — saves the line and opens the quote page.
 * Needs pbq-store.js (window.PBQ). */
(() => {
  const C = window.__PBX_PDP__;
  const root = C && document.getElementById(C.rootId);
  if (!root || !window.PBQ) return;
  const QUOTE_URL = C.quoteUrl || "/pages/quote";
  const VAT = C.vatRate != null ? C.vatRate : 0.15;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, " ").trim() : "");
  const vatMode = () => { try { return localStorage.getItem("pbx-vat-mode") === "excl" ? "excl" : "incl"; } catch { return "incl"; } };
  // "R 12 345,50" → 1234550 cents, in the VAT mode currently on screen → always stored incl VAT.
  const cents = (s) => {
    const t = String(s || "");
    if (!/\d/.test(t)) return null;
    const n = parseFloat(t.replace(/[^\d,.−-]/g, "").replace(/\s/g, "").replace(",", ".").replace("−", "-"));
    if (!isFinite(n)) return null;
    const c = Math.round(n * 100);
    return vatMode() === "excl" ? Math.round(c * (1 + VAT)) : c;
  };

  const ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h3"/></svg>';

  /* labels — the bundle rewrites its buttons on every repaint, so hold ours with an observer */
  function relabel() {
    const q = $("[data-quote]");
    if (q && !q.dataset.pbq) { q.dataset.pbq = "1"; q.innerHTML = `${ICON}<span>Add to quote</span>`; q.classList.add("pbq-addbtn"); }
    const p = $("[data-primary]");
    if (p && /request/i.test(p.textContent)) p.textContent = "Add to quote & send";
    const bar = $("[data-barcta]");
    if (bar && /request/i.test(bar.textContent)) bar.textContent = "Add to quote";
  }
  new MutationObserver(relabel).observe(root, { childList: true, subtree: true, characterData: true });
  relabel();

  /* status line under the buttons: what's already on the quote */
  function status() {
    const ctas = $(".pbx-summary .pbx-ctas");
    if (!ctas) return;
    let el = root.querySelector("[data-pbq-stat]");
    if (!el) {
      el = document.createElement("a");
      el.className = "pbq-stat";
      el.dataset.pbqStat = "";
      el.href = QUOTE_URL;
      ctas.after(el);
    }
    const pb = PBQ.load("pb").length, bk = PBQ.load("bk").length, n = pb + bk;
    el.hidden = !n;
    if (!n) return;
    const parts = [pb && `${pb} Piobox`, bk && `${bk} BLANKD`].filter(Boolean).join(" · ");
    el.innerHTML = `${ICON}<span><b>Your quote</b> · ${n} item${n === 1 ? "" : "s"} <small>(${parts})</small></span><em>View &amp; send &rarr;</em>`;
  }
  document.addEventListener("pbq:change", status);
  status();

  function toast(m) {
    const t = $("[data-toast]");
    if (!t) return;
    t.textContent = m;
    t.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(() => { t.hidden = true; }, 3600);
  }

  function snapshot() {
    const src = $("[data-fv='front']") || $("[data-fv]") || $("[data-stage]");
    if (!src) return "";
    try {
      const c = document.createElement("canvas");
      c.width = c.height = 360;
      const g = c.getContext("2d");
      g.fillStyle = "#EFEFEA"; g.fillRect(0, 0, 360, 360);
      g.drawImage(src, 0, 0, 360, 360);
      return c.toDataURL("image/jpeg", 0.8);
    } catch { return ""; } // tainted canvas: the line still saves, just without its picture
  }

  function add(go) {
    const sizes = {};
    $$("[data-sizes] input[data-s]").forEach((i) => { const n = parseInt(i.value, 10) || 0; if (n > 0) sizes[i.dataset.s] = n; });
    const total = Object.values(sizes).reduce((a, n) => a + n, 0);
    if (!total) {
      toast("Choose your sizes and quantity first.");
      const s = $("[data-openstep='3']");
      if (s && s.getAttribute("aria-expanded") !== "true") s.click();
      $("[data-sizes]")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    const oneSize = Object.keys(sizes).length === 1 && !$(".pbx-size-t");
    const rows = $$("[data-lines] .pbx-l").map((l) => {
      const spans = l.querySelectorAll(":scope > span");
      const amount = txt(spans[1]);
      return { label: txt(l.querySelector("b")), detail: txt(l.querySelector("small")), cents: /free/i.test(amount) ? 0 : cents(amount) };
    });
    const unpriced = rows.some((r) => r.cents == null);
    const notes = $$("[data-notes] .pbx-soft-warn").map(txt).filter(Boolean);
    const branded = rows.filter((r) => /^Branding/i.test(r.label));
    const drop = $("[data-drop]");
    const line = {
      brand: "piobox",
      id: "PB" + Date.now().toString(36).toUpperCase(),
      handle: C.product.handle,
      title: C.product.title,
      url: location.pathname,
      colour: txt($("[data-colname]")),
      image: snapshot(),
      sizes,
      sizeText: oneSize ? `${total}` : Object.entries(sizes).map(([s, q]) => `${q} × ${s}`).join(", "),
      total,
      print: branded.length ? branded.map((r) => r.label.replace(/^Branding · /, "")).join(" + ") : "No branding",
      method: branded.length ? ($(".pbx-method-line > span")?.firstChild?.textContent || "").trim() : "",
      artwork: drop && drop.classList.contains("has") ? txt($("[data-droptxt] b")) : "To follow",
      rows,
      notes,
      estimate: unpriced ? null : cents($("[data-bigv]")?.textContent),
      edited: false,
      ts: Date.now(),
    };
    if (!PBQ.add("pb", line)) { toast("Your browser blocked saving the quote — try a normal window."); return; }
    if (go) { location.href = QUOTE_URL; return; }
    const n = PBQ.count();
    toast(`Added to your quote · ${n} item${n === 1 ? "" : "s"}. Keep adding, then send it all at once.`);
    root.querySelector("[data-pbq-stat]")?.classList.add("is-pop");
    setTimeout(() => root.querySelector("[data-pbq-stat]")?.classList.remove("is-pop"), 700);
  }

  // Capture phase on document: runs before the bundle's own click handler on the root, so the
  // old single-product quote drawer never opens.
  document.addEventListener("click", (e) => {
    const b = e.target.closest && e.target.closest("button");
    if (!b || !root.contains(b)) return;
    let go = null;
    if (b.matches("[data-quote]")) go = false;
    else if (b.matches("[data-primary]") && /quote/i.test(b.textContent)) go = true;
    else if (b.matches("[data-barcta]") && b.dataset.act === "cart" && /quote/i.test(b.textContent)) go = true;
    if (go === null) return;
    e.preventDefault();
    e.stopPropagation();
    add(go);
  }, true);
})();
